/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import { useClickableA11y } from "../../../hooks/a11y/useClickableA11y";

const StyledBookingStepItem = styled.div`
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: ${({ theme }) => theme.borderRadius.md};
  transition: border-color 0.2s ease, background-color 0.2s ease;

  ${({ $clickable, $selected, $disabled, theme }) => css`
    ${$clickable &&
    `
      cursor: pointer;

      @media (hover: hover) {
        &:hover {
          border-color: rgba(${theme.colors.accent.rgba});
          background: rgba(${theme.colors.accent.rgb}, 0.15);
        }
      }
    `}

    ${$selected &&
    `
      border-color: rgba(${theme.colors.accent.rgba});
    `}
    
    ${$disabled &&
    `
      opacity: 0.4;
      pointer-events: none;
    `}
  `}
`;

const BookingStepItem = React.forwardRef(({ children, disabled, selected, onClick, ...props }, ref) => {
  const a11yProps = useClickableA11y({ onClick, disabled, selected });

  return (
    <StyledBookingStepItem
      ref={ref}
      onClick={onClick}
      $disabled={disabled}
      $selected={selected}
      $clickable={onClick}
      {...a11yProps}
      {...props}
    >
      {children}
    </StyledBookingStepItem>
  );
});

export default BookingStepItem;
